module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_miyakojima-800200851fa5dd672201efa8d1996325.webp";